import { render } from "./TheHeader.vue?vue&type=template&id=2fe11706&scoped=true"
import script from "./TheHeader.vue?vue&type=script&lang=js"
export * from "./TheHeader.vue?vue&type=script&lang=js"

import "./TheHeader.vue?vue&type=style&index=0&id=2fe11706&scoped=true&lang=css"

import exportComponent from "/var/www/html/garbage/front_end/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2fe11706"]])

export default __exports__